module.exports = __webpack_public_path__ + "img/hosting.1f59dde.svg";